var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-color-picker',{staticClass:"ma-2",attrs:{"show-swatches":"","swatches-max-height":"200px"},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})}
var staticRenderFns = []

export { render, staticRenderFns }